<mat-card
  class="card-table has-progress-bar"
  [class.card-has-subtitle]="
    estimateDetails?.message != null || estimateDetails?.estimateType === 'custom'
  "
>
  <mat-progress-bar [mode]="(progress$ | async) ? 'indeterminate' : 'determinate'"></mat-progress-bar>

  <mat-card-title fxLayout="row" fxLayoutAlign="space-between center">
    <span>
      <ng-container *ngIf="estimateDetails?.estimateType === 'custom'">
        {{ 'patient-details.estimate-card.manual-estimate' | translate }}
        <ng-container *ngIf="estimateDetails.clinician">
          {{ 'common.by' | translate }} {{ estimateDetails.clinician.name }}
        </ng-container>
      </ng-container>
      <ng-container
        *ngIf="
          estimateDetails?.estimateType !== 'custom' &&
          estimateDetails?.insuranceCarrier?.clinicCarrierName
        "
      >
        {{ 'patient-details.estimate-card.estimate' | translate }}
        {{ 'common.for' | translate }}
        {{ estimateDetails.insuranceCarrier.clinicCarrierName }}
      </ng-container>
      <ng-container
        *ngIf="
          estimateDetails?.estimateType !== 'custom' &&
          !estimateDetails?.insuranceCarrier?.clinicCarrierName
        "
      >
        {{ 'patient-details.estimate-card.estimate' | translate }}
      </ng-container>
    </span>
    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="1rem">
      <sat-popover #advancedSettings hasBackdrop verticalAlign="below">
        <mat-card>
          <mat-card-content fxLayout="column" fxLayoutGap="1rem">
            <mat-form-field appearance="fill">
              <mat-label>{{
                'patient-details.estimate-card.primary-payer' | translate
              }}</mat-label>
              <mat-select
                fxFlex
                [(ngModel)]="estimateDetails.insuranceType"
                (ngModelChange)="valueChanged()"
              >
                <mat-option value="medical">{{
                  'patient-details.estimate-card.advanced.select.medical-insurance'
                    | translate
                }}</mat-option>
                <mat-option value="selfpay">{{
                  'patient-details.estimate-card.advanced.select.selfpay'
                    | translate
                }}</mat-option>
                <mat-option value="lien">{{
                  'patient-details.estimate-card.advanced.select.lien'
                    | translate
                }}</mat-option>
                <mat-option value="wc">{{
                  'patient-details.estimate-card.advanced.select.workers'
                    | translate
                }}</mat-option>
                <mat-option value="inmate">{{
                  'patient-details.estimate-card.advanced.select.inmate'
                    | translate
                }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-slide-toggle
              [disabled]="estimateDetails.insuranceType !== 'medical'"
              [(ngModel)]="estimateDetails.hasSecondary"
              (ngModelChange)="valueChanged()"
            >
              {{
                'patient-details.estimate-card.advanced.secondary-insurance'
                  | translate
              }}
            </mat-slide-toggle>
            <mat-slide-toggle
              [disabled]="
                estimateDetails.insuranceType !== 'medical' || !estimateDetails.hasSecondary
              "
              [(ngModel)]="estimateDetails.secondaryInsuranceCoversDeductible"
              (ngModelChange)="valueChanged()"
            >
              {{
                'patient-details.estimate-card.advanced.secondary-covers-deductible'
                  | translate
              }}
            </mat-slide-toggle>
            <mat-slide-toggle
              [disabled]="
                estimateDetails.insuranceType !== 'medical' || !estimateDetails.hasSecondary
              "
              [(ngModel)]="estimateDetails.secondaryInsuranceCoversCopayment"
              (ngModelChange)="valueChanged()"
            >
              {{
                'patient-details.estimate-card.advanced.secondary-covers-copayment'
                  | translate
              }}
            </mat-slide-toggle>
            <mat-slide-toggle
              [disabled]="
                estimateDetails.insuranceType !== 'medical' || !estimateDetails.hasSecondary
              "
              [(ngModel)]="estimateDetails.secondaryInsuranceCoversCoinsurance"
              (ngModelChange)="valueChanged()"
            >
              {{
                'patient-details.estimate-card.advanced.secondary-covers-coinsurance'
                  | translate
              }}
            </mat-slide-toggle>
            <!-- <mat-slide-toggle [(ngModel)]="showUnits">
              Show quantity/units
            </mat-slide-toggle> -->
            <ng-container *ngIf="isPricerEnabled">
              <a mat-button color="primary" *ngIf="hasPBTrace()" (click)="pbTrace()">
                {{ 'patient-details.estimate-card.advanced.pb-trace-link' | translate }}
              </a>
              <a mat-button color="primary" *ngIf="hasHBTrace()" (click)="hbTrace()">
                {{ 'patient-details.estimate-card.advanced.hb-trace-link' | translate }}
              </a>
            </ng-container>
          </mat-card-content>
          <mat-card-actions fxLayout="column">
            <button
              mat-flat-button
              color="primary"
              type="button"
              (click)="advancedSettings.close()"
            >
              {{
                'patient-details.estimate-card.advanced.close-advanced'
                  | translate
              }}
            </button>
          </mat-card-actions>
        </mat-card>
      </sat-popover>

      <!-- <a
        mat-icon-button
        [matTooltip]="'common.help-center' | translate"
        href="https://ppal.atlassian.net/wiki/spaces/KB/pages/622622/Appointment+Estimates"
        target="_blank"
        rel="noreferrer noopener"
      >
        <mat-icon>help</mat-icon>
      </a> -->

        <button
          mat-stroked-button
          *ngIf="isPricerEnabled"
          (click)="openChargesDialog()"
        >
          <mat-icon>medical_information</mat-icon>
          <span>{{ 'patient-details.estimate-card.update-charges' | translate }}</span>
        </button>
        <button
          mat-stroked-button
          [matTooltip]="
            'patient-details.estimate-card.control-advanced-hint' | translate
          "
          [satPopoverAnchor]="advancedSettings"
          (click)="advancedSettings.open()"
          (popoverClosed)="($event)"
        >
          <mat-icon>tune</mat-icon>
          <span>{{ 'common.advanced' | translate }}</span>
        </button>
        <button
          mat-stroked-button
          *ngIf="estimateDetails.estimateType === 'custom'"
          (click)="resetEstimate()"
          [disabled]="(isSavingRate$ | async) || (isUpdatingEstimate$ | async)"
          [matTooltip]="
            'patient-details.estimate-card.reset-estimate-hint' | translate
          "
        >
          <mat-icon>clear</mat-icon>
          <span>{{ 'common.reset' | translate }}</span>
        </button>
        <ng-container *appHasPermission="'invoice.create'">
          <ng-container *mmxConsoleOnly>
            <button
              *ngIf="estimateDetails.total >= 0 && clinic?.modules.payment"
              mat-flat-button
              color="accent"
              (click)="confirmInvoice()"
              [disabled]="(isSavingRate$ | async) || (isUpdatingEstimate$ | async)"
              [matTooltip]="
              'patient-details.estimate-card.create-invoice-hint' | translate
            "
            >
              <mat-icon>check</mat-icon>
              <span>{{ 'common.confirm' | translate }}</span>
            </button>
          </ng-container>
        </ng-container>
    </div>
  </mat-card-title>

  <mat-card-subtitle *ngIf="estimateDetails.estimateType === 'custom'">
    {{
      'patient-details.estimate-card.text-estimate-customized'
        | translate: { value: app.name }
    }}
  </mat-card-subtitle>

  <mat-card-subtitle *ngIf="estimateDetails?.message" class="text-warn">
    {{ estimateDetails.message }}
  </mat-card-subtitle>

  <mat-card-content>
    <div *ngIf="isPricerEnabled && estimate?.lineItems?.length > 0" class="mb-1">
      <table
        class="mat-mdc-table mat-bordered-table estimate-table charges"
        cellspacing="0"
        cellpadding="0"
      >
        <thead>
          <tr class="mat-mdc-row mat-mdc-header-row emptyheading">
            <th class="mat-mdc-cell mat-mdc-header-cell input" colspan="2">
              <span class="text-primary uppercase text-sm">
                {{ 'patient-details.estimate-card.table-one.charges' | translate }}
              </span>
            </th>
            <th class="mat-mdc-cell mat-mdc-header-cell text-center output">
              <span class="text-primary uppercase text-sm">
                {{ 'patient-details.estimate-card.table-one.units' | translate }}
              </span>
            </th>
            <th class="mat-mdc-cell mat-mdc-header-cell text-center output" *appHasPermission="'appointment.estimate.charge.view'">
              <span class="text-primary uppercase text-sm">
                {{ 'patient-details.estimate-card.table-one.total-charges' | translate }}
              </span>
            </th>
          </tr>
        </thead>
        <tbody class="scrollable-table">
          <ng-container *ngFor="let item of estimate.lineItems">
            <tr class="mat-mdc-row">
              <td class="mat-mdc-cell input" colspan="2">
                {{ item.description}}
              </td>
              <td class="mat-mdc-cell text-center output">
                {{ item.quantity }}
              </td>
              <td class="mat-mdc-cell text-center output" *appHasPermission="'appointment.estimate.charge.view'">
                <ng-container *ngIf="item.expectedAmount; else noExpectedAmount">
                  {{ item.expectedAmount | currency: item.currency }}
                </ng-container>
                <ng-template #noExpectedAmount>
                  {{ item.amount | currency: item.currency }}
                </ng-template>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <table
      class="mat-mdc-table mat-bordered-table estimate-table"
      cellspacing="0"
      cellpadding="0"
    >
      <tbody>
        <tr *ngIf="!isPricerEnabled" class="mat-mdc-row mat-mdc-header-row emptyheading">
          <th class="mat-mdc-cell mat-mdc-header-cell input">
            <span class="text-primary uppercase text-sm">{{
              'patient-details.estimate-card.table-one.procedure' | translate
            }}</span>
          </th>
          <th class="mat-mdc-cell mat-mdc-header-cell text-center output">
            <span class="text-primary uppercase text-sm">{{
              'patient-details.estimate-card.table-one.cpt' | translate
            }}</span>
          </th>
          <th
            *ngIf="showUnits"
            class="mat-mdc-cell mat-mdc-header-cell text-center output"
          >
            <span class="text-primary uppercase text-sm">{{
              'patient-details.estimate-card.table-one.units' | translate
            }}</span>
          </th>
          <th class="mat-mdc-cell mat-header-mdc-cell text-center output">
            <span class="text-primary uppercase text-sm">{{
              'patient-details.estimate-card.table-one.rate' | translate
            }}</span>
          </th>
          <th
            *ngIf="showGlobalRate"
            class="mat-mdc-cell mat-header-mdc-cell text-center output"
          >
            <span class="text-primary uppercase text-sm">{{
              'patient-details.estimate-card.table-one.global-rate' | translate
            }}</span>
          </th>
        </tr>
        <tr *ngIf="isPricerEnabled" class="mat-mdc-row mat-mdc-header-row emptyheading">
          <th class="mat-mdc-cell mat-mdc-header-cell input" colspan="2">
            <span class="text-primary uppercase text-sm">
              {{ 'patient-details.estimate-card.table-one.estimate-summary' | translate }}
            </span>
          </th>
          <th class="mat-mdc-cell mat-mdc-header-cell text-center output">
            <span class="text-primary uppercase text-sm">
              {{ 'patient-details.estimate-card.table-one.total-charges' | translate }}
            </span>
          </th>
          <th class="mat-mdc-cell mat-mdc-header-cell text-center output">
            <span class="text-primary uppercase text-sm">
              {{ 'patient-details.estimate-card.table-one.expected-amount' | translate }}
            </span>
          </th>
        </tr>
        <ng-container *ngIf="isPricerEnabled">
          <ng-container *ngIf="estimate?.hbResponse?.totalPrice">
            <tr class="mat-mdc-row">
              <td class="mat-mdc-cell input" colspan="2">
                Hospital Total Charges/Expected Amount
              </td>
              <td class="mat-mdc-cell text-center output">
                {{ estimate.totalHBCharges | currency: getDefaultCurrency() }}
              </td>
              <td class="mat-mdc-cell text-center output">
                {{ estimate.hbResponse.totalPrice | currency: getDefaultCurrency() }}
              </td>
            </tr>
          </ng-container>
          <ng-container *ngIf="estimate?.pbResponse?.price">
            <tr class="mat-mdc-row">
              <td class="mat-mdc-cell input" colspan="2">
                Professional Total Charges/Expected Amount
              </td>
              <td class="mat-mdc-cell text-center output">
                {{ estimate.getTotalPBCharges() | currency: getDefaultCurrency() }}
              </td>
              <td class="mat-mdc-cell text-center output">
                {{ estimate.pbResponse.price | currency: getDefaultCurrency() }}
              </td>
            </tr>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="!isPricerEnabled">
          <ng-container *ngFor="let product of estimateDetails.products">
            <tr class="mat-mdc-row">
              <td class="mat-mdc-cell input">
                <div
                  fxLayout="row"
                  fxLayoutAlign="start center"
                  fxLayoutGap=".5rem"
                >
                  <span>{{ product.name }}</span>

                  <mat-button
                    *ngIf="
                    product.description ||
                    product.priceType === 'medicare' ||
                    product.priceType === 'rvs-known' ||
                    product.priceType === 'rvs-guesstimated' ||
                    product.preventative
                  "
                    mat-icon-button
                    type="button"
                    [satPopoverAnchor]="productInfo"
                    (click)="productInfo.open()"
                  >
                    <mat-icon>info</mat-icon>
                  </mat-button>
                </div>

                <sat-popover #productInfo hasBackdrop verticalAlign="below">
                  <mat-card>
                    <mat-card-content style="max-width: 550px">
                      <ul>
                        <li *ngIf="product.description">
                          {{
                            'patient-details.estimate-card.medicare-description'
                              | translate
                          }}: {{ product.description }}
                        </li>

                        <li *ngIf="product.priceType === 'medicare'">
                          {{
                            'patient-details.estimate-card.no-allowed-amount'
                              | translate: { value: product.name }
                          }}
                          <span class="text-secondary">{{ product.name }}</span>
                          {{ 'common.with' | translate }}
                          <span class="text-secondary">{{
                              product.clinicCarrierName
                            }}</span
                          >.
                          {{
                            'patient-details.estimate-card.rate-shown' | translate
                          }}
                          <a
                            class="text-link"
                            href="https://www.cms.gov/medicare/physician-fee-schedule/search?Y=0&T=4&HT=0&CT=0&H1={{
                            product.code
                          }}&M=1"
                            target="_blank"
                            [matTooltip]="
                            'patient-details.estimate-card.medicare-price-hint'
                              | translate
                          "
                          >{{
                              'patient-details.estimate-card.medicare-price'
                                | translate
                            }}</a
                          >.
                        </li>

                        <li *ngIf="product.priceType === 'rvs-known'">
                          {{
                            'patient-details.estimate-card.rate-shown-calculated'
                              | translate
                          }}
                          <dfn matTooltip="Medicare Relative Value Scale"
                          >Medicare RVS</dfn
                          >
                          of {{ product.rvs?.toFixed(2) }} for
                          <span class="text-secondary">{{
                              product.clinicCarrierName
                            }}</span
                          >.
                        </li>

                        <li *ngIf="product.priceType === 'rvs-guesstimated'">
                          {{
                            'patient-details.estimate-card.estimate-based-calculated'
                              | translate
                          }}
                          <dfn matTooltip="Medicare Relative Value Scale"
                          >Medicare RVS</dfn
                          >
                          of {{ product.rvs?.toFixed(2) }} for
                          <span class="text-secondary">{{
                              product.clinicCarrierName
                            }}</span
                          >.
                        </li>

                        <li *ngIf="product.feeScheduleId">
                        <span
                          [innerHTML]="
                            'patient-details.estimate-card.fee-schedule-price'
                              | translate
                                : {
                                    value1: product.feeScheduleName,
                                    value2:
                                      '/settings/fee-schedules/' +
                                      product.feeScheduleId +
                                      '/info'
                                  }
                          "
                        ></span>
                        </li>

                        <li *ngIf="product.preventative">
                          <strong
                          >{{
                              'patient-details.estimate-card.preventative'
                                | translate
                            }}.</strong
                          >
                          {{
                            'patient-details.estimate-card.patient-incurs'
                              | translate
                          }}
                        </li>
                      </ul>
                    </mat-card-content>
                  </mat-card>
                </sat-popover>
              </td>
              <td
                class="mat-mdc-cell text-center output"
                *ngIf="
                product.code != null && product.codeType === 'known';
                else noCode
              "
              >
                {{ product.code }}
                <ng-container *ngIf="product.modifiers?.length > 0">
                  {{ product.modifiers.join('') }}
                </ng-container>
              </td>
              <ng-template #noCode>
                <td
                  class="mat-mdc-cell editablefield text-center output"
                  [satPopoverAnchor]="pc"
                  (click)="pc.open()"
                  (popoverClosed)="detectProcedureCodeChanged(product)"
                >
                  <div fxLayout="row" fxLayoutAlign="center center">
                  <span *ngIf="product.code != null" class="editable">
                    {{ product.code }}
                    <ng-container *ngIf="product.codeModifier">
                      {{ product.codeModifier }}
                    </ng-container>
                  </span>
                    <span *ngIf="product.code == null" class="editable">{{
                        'common.none' | translate
                      }}</span>
                    <mat-icon class="edit-icon">edit</mat-icon>
                    <sat-popover
                      #pc
                      hasBackdrop
                      (backdropClicked)="detectProcedureCodeChanged(product)"
                    >
                      <mat-card
                        class="p5"
                        fxLayout="row"
                        fxLayoutGap="1rem"
                        *ngIf="
                        filteredCodes[product.id] &&
                        filteredCodeModifiers[product.id]
                      "
                      >
                        <input
                          type="string"
                          matInput
                          placeholder="CPT/HCPCS Code"
                          name="cptCode"
                          [matAutocomplete]="autocompleteProcedureCode"
                          [formControl]="form.controls[product.id + '-code']"
                          (keyup)="onPopoverKeyup($event, nt)"
                        />

                        <mat-autocomplete
                          autoActiveFirstOption
                          #autocompleteProcedureCode="matAutocomplete"
                        >
                          <mat-option
                            *ngFor="let cpt of filteredCodes[product.id] | async"
                            [value]="cpt.code"
                            [matTooltip]="cpt.name"
                          >
                            {{ cpt.code }} {{ cpt.name }}
                          </mat-option>
                        </mat-autocomplete>

                        <input
                          type="string"
                          matInput
                          placeholder="Code Modifier"
                          name="codeModifier"
                          [matAutocomplete]="autocompleteProcedureCodeModifier"
                          [formControl]="
                          form.controls[product.id + '-codeModifier']
                        "
                          (keyup)="onPopoverKeyup($event, nt)"
                        />

                        <mat-autocomplete
                          autoActiveFirstOption
                          #autocompleteProcedureCodeModifier="matAutocomplete"
                        >
                          <mat-option
                            *ngFor="
                            let cpt of filteredCodeModifiers[product.id] | async
                          "
                            [value]="modifier.code"
                            [matTooltip]="modifier.abbreviation"
                          >
                            {{ modifier.code }} {{ modifier.abbreviation }}
                          </mat-option>
                        </mat-autocomplete>
                      </mat-card>
                    </sat-popover>
                  </div>
                </td>
              </ng-template>
              <td
                *ngIf="showUnits"
                class="mat-mdc-cell editablefield text-center output"
                [satPopoverAnchor]="unitPopover"
                (click)="unitPopover.open()"
                (popoverClosed)="closed()"
              >
                <div fxLayout="row" fxLayoutAlign="center center">
                  <span class="editable">{{ product.quantity ?? 1 }}</span>
                  <mat-icon class="edit-icon">edit</mat-icon>
                  <sat-popover #unitPopover hasBackdrop>
                    <mat-card>
                      <mat-card-content>
                        <mat-form-field appearance="outline">
                          <mat-label>{{'common.amount' | translate}}</mat-label>
                          <input
                            type="number"
                            min="0"
                            matInput
                            [ngModel]="product.quantity"
                            (ngModelChange)="priceChanged(product, $event)"
                            [ngModelOptions]="{ updateOn: 'blur' }"
                            (keyup)="onPopoverKeyup($event, unitPopover)"
                          />
                        </mat-form-field>
                      </mat-card-content>
                    </mat-card>
                  </sat-popover>
                </div>
              </td>
              <td
                class="mat-mdc-cell editablefield text-center output"
                [satPopoverAnchor]="nt"
                (click)="nt.open()"
                (popoverClosed)="closed()"
              >
                <div fxLayout="row" fxLayoutAlign="center center">
                <span class="editable" *ngIf="product.price != null">{{
                    product.price
                      | currency: getDefaultCurrency(product.priceCurrency)
                  }}</span>
                  <span class="editable" *ngIf="product.price == null">{{
                      'common.none' | translate
                    }}</span>
                  <mat-icon class="edit-icon">edit</mat-icon>
                  <sat-popover #nt hasBackdrop>
                    <mat-card>
                      <mat-card-content>
                        <mat-form-field appearance="outline">
                          <mat-label>{{'common.amount' | translate}}</mat-label>
                          <input
                            type="number"
                            min="0"
                            matInput
                            [ngModel]="product.price"
                            (ngModelChange)="priceChanged(product, $event)"
                            [ngModelOptions]="{ updateOn: 'blur' }"
                            (keyup)="onPopoverKeyup($event, nt)"
                          />
                        </mat-form-field>
                      </mat-card-content>
                    </mat-card>
                  </sat-popover>
                </div>
              </td>
              <td
                *ngIf="showGlobalRate"
                class="mat-mdc-cell text-center output"
              >
                <span *ngIf="product.billAmount != null">{{
                  product.billAmount
                    | currency: getDefaultCurrency(product.priceCurrency)
                }}</span>
                <span *ngIf="product.billAmount == null">{{
                  'common.none' | translate
                }}</span>
              </td>
            </tr>

            <tr
              class="mat-mdc-row emptyheading estimate-row-error"
              *ngIf="product.code == null && hasSuggestion(product, 0)"
            >
              <td class="mat-mdc-cell text-center output" colspan="2">
                <div fxLayout="column">
                <span
                >{{ 'patient-details.estimate-card.no-cpt' | translate }}
                  {{ product.name }}.
                  {{
                    'patient-details.estimate-card.suggestions' | translate
                  }}:</span
                >
                  <button
                    mat-flat-button
                    [matTooltip]="
                    'patient-details.estimate-card.no-cpt-hint'
                      | translate
                        : {
                            value1: product.name,
                            value2: getSuggestion(product, 0).code
                          }
                  "
                    (click)="
                    procedureCodeChanged(
                      product,
                      getSuggestion(product, 0).code
                    )
                  "
                  >
                    {{ getSuggestion(product, 0).code }}
                    {{ getSuggestion(product, 0).name }}
                  </button>
                  <ng-container *ngIf="hasSuggestion(product, 1)">
                    <button
                      mat-flat-button
                      [matTooltip]="
                      'patient-details.estimate-card.no-cpt-hint'
                        | translate
                          : {
                              value1: product.name,
                              value2: getSuggestion(product, 1).code
                            }
                    "
                      (click)="
                      procedureCodeChanged(
                        product,
                        getSuggestion(product, 1).code
                      )
                    "
                    >
                      {{ getSuggestion(product, 1).code }}
                      {{ getSuggestion(product, 1).name }}
                    </button>
                  </ng-container>
                  <!-- Save rate of <strong>{{ product.price | currency:product.priceCurrency }}</strong> for {{ product.name }} for carrier
                  <strong>{{ product.clinicCarrierName }}</strong>?
                <button mat-button color="primary" (click)="saveRate(product)" matTooltip="Save this rate" [disabled]="isSavingRate$ | async">
                  <mat-icon>check</mat-icon>
                  {{ 'common.yes' | translate }}
                </button> -->
                </div>
              </td>
            </tr>

            <tr
              class="mat-mdc-row emptyheading estimate-row-error"
              *ngIf="
              product.price != null &&
              !product.hasRate &&
              product.carrierLookupId &&
              product.priceType === 'manual'
            "
            >
              <td class="mat-mdc-cell text-center output" colspan="2">
              <span>
                {{ 'patient-details.estimate-card.save-rate' | translate }}
                <strong>{{
                    product.price
                      | currency: getDefaultCurrency(product.priceCurrency)
                  }}</strong>
                for {{ product.name }} for carrier
                <strong>{{ product.clinicCarrierName }}</strong
                >?
                <button
                  mat-button
                  color="primary"
                  (click)="saveRate(product)"
                  [matTooltip]="
                    'patient-details.estimate-card.save-this-rate' | translate
                  "
                  [disabled]="isSavingRate$ | async"
                >
                  <mat-icon>check</mat-icon>
                  {{ 'common.yes' | translate }}
                </button>
              </span>
              </td>
            </tr>

            <tr
              class="mat-mdc-row emptyheading estimate-row-error"
              *ngIf="
              product.code != null &&
              product.carrierLookupId &&
              product.codeType === 'manual'
            "
            >
              <td class="mat-mdc-cell text-center output" colspan="2">
              <span>
                {{
                  'patient-details.estimate-card.save-procedure' | translate
                }}
                <strong>{{ product.code }}</strong> to {{ product.name }}?
                <button
                  mat-button
                  color="primary"
                  (click)="saveCode(product)"
                  [disabled]="isSavingCode$ | async"
                >
                  <mat-icon>check</mat-icon>
                  {{ 'common.yes' | translate }}
                </button>
              </span>
              </td>
            </tr>

            <tr
              class="mat-mdc-row emptyheading estimate-row-error"
              *ngIf="product.price == null && product.code == null"
            >
              <td class="mat-mdc-cell text-center output" colspan="2">
              <span class="text-warn text-sm">
                {{ 'patient-details.estimate-card.attach-cpt' | translate }}
                {{ product.name }}.
              </span>
              </td>
            </tr>

            <tr
              class="mat-mdc-row emptyheading estimate-row-error"
              *ngIf="product.price == null && product.code != null"
            >
              <td class="mat-mdc-cell text-center output" colspan="2">
              <span class="text-warn text-sm">
                {{
                  'patient-details.estimate-card.no-allowed-amount'
                    | translate: { value: product.name }
                }}
              </span>
              </td>
            </tr>
          </ng-container>
        </ng-container>
        <tr class="mat-mdc-row">
          <td class="mat-mdc-cell input" colspan="2">
            {{'patient-details.estimate-card.patient-visit-total' | translate }}
          </td>
          <ng-container *appHasPermission="['estimate.create']; else noPermission">
            <td
              class="mat-mdc-cell editablefield text-center output"
              [satPopoverAnchor]="nt"
              (click)="nt.open()"
              (popoverClosed)="closed()"
            >
              <div fxLayout="row" fxLayoutAlign="center center">
              <span class="editable" *ngIf="estimateDetails.total != null">
                {{ estimateDetails.total | currency: getDefaultCurrency() }}
              </span>
                <span class="editable" *ngIf="estimateDetails.total == null">
                {{ 'common.none' | translate }}
              </span>
                <mat-icon class="edit-icon">edit</mat-icon>
                <sat-popover #nt hasBackdrop>
                  <mat-card>
                    <mat-card-content>
                      <mat-form-field appearance="outline">
                        <mat-label>{{'common.amount' | translate}}</mat-label>
                        <input
                          type="number"
                          min="0"
                          matInput
                          [(ngModel)]="estimateDetails.total"
                          (ngModelChange)="valueChanged()"
                          [ngModelOptions]="{ updateOn: 'blur' }"
                          (keyup)="onPopoverKeyup($event, nt)"
                        />
                      </mat-form-field>
                    </mat-card-content>
                  </mat-card>
                </sat-popover>
              </div>
            </td>
          </ng-container>
          <ng-template #noPermission>
            <td class="mat-mdc-cell text-center output">
              <div fxLayout="row" fxLayoutAlign="center center">
                <span *ngIf="estimateDetails.total != null">
                  {{ estimateDetails.total | currency: getDefaultCurrency() }}
                </span>
                  <span *ngIf="estimateDetails.total == null">
                  {{ 'common.none' | translate }}
                </span>
              </div>
            </td>
          </ng-template>
          <td *ngIf="showGlobalRate" class="mat-mdc-cell text-center output"></td>
        </tr>
        <tr
          *ngIf="
            estimateDetails.insuranceType === 'medical' &&
            estimateDetails.totalBillableToPatient != null &&
            estimateDetails.totalBillableToPatient !== estimateDetails.total
          "
          class="mat-mdc-row"
        >
          <td class="mat-mdc-cell input" colspan="2">
            {{ 'patient-details.estimate-card.total-billable' | translate }}
          </td>
          <td
            class="mat-mdc-cell editablefield text-center output"
            [satPopoverAnchor]="nb2p"
            (click)="nb2p.open()"
            (popoverClosed)="closed()"
          >
            <div fxLayout="row" fxLayoutAlign="center center">
              <span class="editable">
                {{ estimateDetails.totalBillableToPatient | currency: getDefaultCurrency() }}
              </span>
              <mat-icon class="edit-icon">edit</mat-icon>
              <sat-popover #nb2p hasBackdrop>
                <mat-card>
                  <mat-card-content>
                    <mat-form-field appearance="outline">
                      <mat-label>{{'common.amount' | translate}}</mat-label>
                      <input
                        type="number"
                        min="0"
                        matInput
                        [(ngModel)]="estimateDetails.totalBillableToPatient"
                        (ngModelChange)="valueChanged()"
                        [ngModelOptions]="{ updateOn: 'blur' }"
                        (keyup)="onPopoverKeyup($event, nb2p)"
                      />
                    </mat-form-field>
                  </mat-card-content>
                </mat-card>
              </sat-popover>
            </div>
          </td>
          <td *ngIf="showGlobalRate" class="mat-mdc-cell text-center output"></td>
        </tr>
        <tr
          class="mat-mdc-row emptyheading estimate-row-error"
          *ngIf="hasNoProducts$ | async"
        >
          <td class="mat-mdc-cell text-center output" colspan="2">
            <mat-error>
              {{
                'patient-details.estimate-card.no-procedures-associated'
                  | translate
              }}
            </mat-error>
          </td>
        </tr>
        <tr
          class="mat-mdc-row emptyheading estimate-row-error"
          *ngIf="(hasNoEligibility$ | async) && (hasInsurances$ | async)"
        >
          <td class="mat-mdc-cell text-center output" colspan="2">
            <mat-error>
              {{
                'patient-details.estimate-card.no-eligibility-pulled'
                  | translate
              }}
            </mat-error>
          </td>
        </tr>
        <tr
          class="mat-mdc-row emptyheading estimate-row-error"
          *ngIf="productsMissingServiceCode.length > 0"
        >
          <td class="mat-mdc-cell text-center output" colspan="2">
            <span class="text-warn">
              {{ 'patient-details.estimate-card.no-x12-service' | translate }}
            </span>
            <ul>
              <li *ngFor="let product of productsMissingServiceCode">
                {{ product.name }}
              </li>
            </ul>
            <span>{{
              'patient-details.estimate-card.without-x12'
                | translate: { value: app.name }
            }}</span>
          </td>
        </tr>
        <ng-container *ngIf="estimateDetails.insuranceType === 'medical'">
          <tr class="mat-mdc-row mat-header-row emptyheading">
            <th class="mat-mdc-cell mat-mdc-header-cell input">
              <span class="text-primary uppercase text-sm">
                {{
                  'patient-details.estimate-card.table-two.benefit-item'
                    | translate
                }}
              </span>
            </th>
            <th class="mat-mdc-cell mat-mdc-header-cell text-center output">
              <span class="text-primary uppercase text-sm">
                {{
                  'patient-details.estimate-card.table-two.benefit-amount'
                    | translate
                }}
              </span>
            </th>
            <th class="mat-mdc-cell mat-mdc-header-cell text-center output">
              <span class="text-primary uppercase text-sm">
                {{
                  'patient-details.estimate-card.table-two.applied' | translate
                }}
              </span>
            </th>
          </tr>
          <tr class="mat-mdc-row">
            <td class="mat-mdc-cell input">
              {{
                'patient-details.estimate-card.table-two.remaining-deductible'
                  | translate
              }}
            </td>
            <td
              class="mat-mdc-cell editablefield text-center output"
              [satPopoverAnchor]="dfr"
              (click)="dfr.open()"
              (popoverClosed)="closed()"
            >
              <div fxLayout="row" fxLayoutAlign="center center">
                <span class="editable" *ngIf="estimateDetails.deductible != null">{{
                  estimateDetails.deductible | currency: getDefaultCurrency()
                }}</span>
                <span class="editable" *ngIf="estimateDetails.deductible == null">{{
                  'common.none' | translate
                }}</span>
                <mat-icon class="edit-icon">edit</mat-icon>
                <sat-popover #dfr hasBackdrop>
                  <mat-card>
                    <mat-card-content>
                      <mat-form-field appearance="outline">
                        <mat-label>{{'common.amount' | translate}}</mat-label>
                        <input
                          type="number"
                          matInput
                          [(ngModel)]="estimateDetails.deductible"
                          (ngModelChange)="valueChanged()"
                          [ngModelOptions]="{ updateOn: 'blur' }"
                          (keyup)="onPopoverKeyup($event, dfr)"
                        />
                      </mat-form-field>
                    </mat-card-content>
                  </mat-card>
                </sat-popover>
              </div>
              <!-- {{ serviceCode }} -->
            </td>
            <td class="mat-mdc-cell text-center output">
              {{ estimateDetails.deductibleApplied | currency: getDefaultCurrency() }}
            </td>
          </tr>
          <tr class="mat-mdc-row">
            <td class="mat-mdc-cell input">
              {{ 'patient-details.estimate-card.table-two.copay' | translate }}
            </td>
            <td
              class="mat-mdc-cell editablefield text-center output"
              [satPopoverAnchor]="cop"
              (click)="cop.open()"
              (popoverClosed)="closed()"
            >
              <div fxLayout="row" fxLayoutAlign="center center">
                <span class="editable" *ngIf="estimateDetails.copayment != null">{{
                  estimateDetails.copayment | currency: getDefaultCurrency()
                }}</span>
                <span class="editable" *ngIf="estimateDetails.copayment == null">{{
                  'common.none' | translate
                }}</span>
                <mat-icon class="edit-icon">edit</mat-icon>
                <sat-popover #cop hasBackdrop>
                  <mat-card>
                    <mat-card-content>
                      <mat-form-field appearance="outline">
                        <mat-label>{{'common.amount' | translate}}</mat-label>
                        <input
                          type="number"
                          matInput
                          [(ngModel)]="estimateDetails.copayment"
                          (ngModelChange)="valueChanged()"
                          [ngModelOptions]="{ updateOn: 'blur' }"
                          (keyup)="onPopoverKeyup($event, cop)"
                        />
                      </mat-form-field>
                    </mat-card-content>
                  </mat-card>
                </sat-popover>
              </div>
            </td>
            <td class="mat-mdc-cell text-center output">
              {{ estimateDetails.copaymentApplied | currency: getDefaultCurrency() }}
            </td>
          </tr>
          <tr class="mat-mdc-row">
            <td class="mat-mdc-cell input">
              {{
                'patient-details.estimate-card.table-two.coinsurance'
                  | translate
              }}
            </td>
            <td
              class="mat-mdc-cell editablefield text-center output"
              [satPopoverAnchor]="coi"
              (click)="coi.open()"
              (popoverClosed)="closed()"
            >
              <div fxLayout="row" fxLayoutAlign="center center">
                <span class="editable" *ngIf="estimateDetails.coinsurance != null"
                  >{{ coinsurancePercent }}%</span
                >
                <span class="editable" *ngIf="estimateDetails.coinsurance == null">{{
                  'common.none' | translate
                }}</span>
                <mat-icon class="edit-icon">edit</mat-icon>
                <sat-popover #coi hasBackdrop>
                  <mat-card>
                    <mat-card-content>
                      <mat-form-field appearance="outline">
                        <mat-label>{{'common.amount' | translate}}</mat-label>
                        <input
                          type="number"
                          min="0"
                          matInput
                          [(ngModel)]="coinsurancePercent"
                          (ngModelChange)="valueChanged()"
                          [ngModelOptions]="{ updateOn: 'blur' }"
                          (keyup)="onPopoverKeyup($event, coi)"
                        />
                      </mat-form-field>
                    </mat-card-content>
                  </mat-card>
                </sat-popover>
              </div>
            </td>
            <td class="mat-mdc-cell text-center output">
              {{ estimateDetails.coinsuranceApplied | currency: getDefaultCurrency() }}
            </td>
          </tr>
          <tr class="mat-mdc-row">
            <td class="mat-mdc-cell input">
              {{
                'patient-details.estimate-card.table-two.out-of-pocket'
                  | translate
              }}
            </td>
            <td
              class="mat-mdc-cell editablefield text-center output"
              [satPopoverAnchor]="ofr"
              (click)="ofr.open()"
              (popoverClosed)="closed()"
            >
              <div fxLayout="row" fxLayoutAlign="center center">
                <span class="editable" *ngIf="estimateDetails.outOfPocketMax != null">{{
                  estimateDetails.outOfPocketMax | currency: getDefaultCurrency()
                }}</span>
                <span class="editable" *ngIf="estimateDetails.outOfPocketMax == null">{{
                  'common.none' | translate
                }}</span>
                <mat-icon class="edit-icon">edit</mat-icon>
                <sat-popover #ofr hasBackdrop>
                  <mat-card>
                    <mat-card-content>
                      <mat-form-field appearance="outline">
                        <mat-label>{{'common.amount' | translate}}</mat-label>
                        <input
                          type="number"
                          matInput
                          [(ngModel)]="estimateDetails.outOfPocketMax"
                          (ngModelChange)="valueChanged()"
                          [ngModelOptions]="{ updateOn: 'blur' }"
                          [disabled]="estimateDetails.outOfPocketMax == null"
                          (keyup)="onPopoverKeyup($event, ofr)"
                        />
                      </mat-form-field>
                      <mat-checkbox
                        [checked]="estimateDetails.outOfPocketMax == null"
                        (change)="onOutOutPocketNilChange($event)"
                      >
                        {{ 'common.none' | translate }}
                      </mat-checkbox>
                    </mat-card-content>
                  </mat-card>
                </sat-popover>
              </div>
            </td>
            <td class="mat-mdc-cell text-center output">
              <ng-container *ngIf="estimateDetails.outOfPocketMaxApplied == null"
                >N/A</ng-container
              >
              <ng-container *ngIf="estimateDetails.outOfPocketMaxApplied != null">
                <strong>{{
                  'patient-details.estimate-card.table-two.out-of-pocket-hit'
                    | translate
                }}</strong>
                <br />
                {{
                  estimateDetails.outOfPocketMaxApplied
                    | currency: getDefaultCurrency()
                }}
              </ng-container>
            </td>
          </tr>
          <tr class="mat-mdc-row" *ngIf="estimateDetails.hasSecondary">
            <td class="mat-mdc-cell input">
              {{
                'patient-details.estimate-card.table-two.secondary-insurance'
                  | translate
              }}
            </td>
            <td
              class="mat-mdc-cell text-center output"
              [innerHTML]="secondaryCoverageSummary()"
            >
              <!-- <mat-checkbox [checked]="estimateDetails.secondaryInsuranceCoversDeductible">Deductible</mat-checkbox>
            <mat-checkbox [checked]="estimateDetails.secondaryInsuranceCoversCopayment">Copayment</mat-checkbox>
            <mat-checkbox [checked]="estimateDetails.secondaryInsuranceCoversCoinsurance">Coinsurance</mat-checkbox> -->
            </td>
            <td class="mat-mdc-cell text-center output">
              <ng-container
                *ngIf="estimateDetails.secondaryInsuranceResponsibility == null"
                >N/A</ng-container
              >
              <ng-container
                *ngIf="estimateDetails.secondaryInsuranceResponsibility != null"
              >
                {{
                  estimateDetails.secondaryInsuranceResponsibility * -1
                    | currency: getDefaultCurrency()
                }}
              </ng-container>
            </td>
          </tr>
        </ng-container>

        <tr class="mat-mdc-row">
          <td class="mat-mdc-cell input"></td>
          <td class="mat-mdc-cell text-center output">
            <div *ngIf="estimateDetails.insuranceType === 'medical'" fxLayout="column">
              <span>{{
                'patient-details.estimate-card.table-two.insurance-pays'
                  | translate
              }}</span>
              <span>
                <ng-container *ngIf="estimateDetails.hasSecondary">{{
                  'common.primary' | translate
                }}</ng-container>
                {{
                  estimateDetails.insuranceResponsibility
                    | currency: getDefaultCurrency()
                }}
                <ng-container *ngIf="estimateDetails.hasSecondary">
                  / {{ 'common.secondary' | translate }}
                  {{
                    estimateDetails.secondaryInsuranceResponsibility || 0
                      | currency: getDefaultCurrency()
                  }}
                </ng-container>
              </span>
            </div>
            <ng-container *ngIf="estimateDetails.insuranceType === 'selfpay'">
              <strong>{{
                'patient-details.estimate-card.advanced.select.selfpay'
                  | translate
              }}</strong>
            </ng-container>
            <div
              *ngIf="
                estimateDetails.insuranceType === 'lien' ||
                estimateDetails.insuranceType === 'wc' ||
                estimateDetails.insuranceType === 'inmate'
              "
              fxLayout="column"
            >
              <span *ngIf="estimateDetails.insuranceType === 'lien'">{{
                'patient-details.estimate-card.advanced.select.lien' | translate
              }}</span>
              <span *ngIf="estimateDetails.insuranceType === 'wc'">{{
                'patient-details.estimate-card.advanced.select.workers'
                  | translate
              }}</span>
              <span *ngIf="estimateDetails.insuranceType === 'inmate'">{{
                'patient-details.estimate-card.advanced.select.inmate'
                  | translate
              }}</span>
              <span>
                {{
                  estimateDetails.insuranceResponsibility
                    | currency: getDefaultCurrency()
                }}
              </span>
            </div>
          </td>
          <td class="mat-mdc-cell text-center output">
            <div fxLayout="column">
              <strong>{{
                'patient-details.estimate-card.patient-responsibility'
                  | translate
              }}</strong>
              <span>{{
                estimateDetails.patientsResponsibility | currency: getDefaultCurrency()
              }}</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </mat-card-content>
</mat-card>
